import { useEffect, useState, useRef } from 'react';

import { useHistory } from "react-router-dom";
import useFetch from 'use-http'
import { useStateMachine } from "little-state-machine";
import updateAction from "./updateAction";

import { loadStripe } from '@stripe/stripe-js';

import {
    Elements, useStripe, useElements,
    CardNumberElement,
    CardCvcElement,
    CardExpiryElement
} from '@stripe/react-stripe-js';
import StatusMessages, { useMessages } from './StatusMessages'

import './stripe.css';


const CheckoutForm = (props) => {
    let history = useHistory();
    const termsCheck = useRef();
    const stripe = useStripe();
    const elements = useElements();
    const [postal, setPostal] = useState('');
    const [reasonTerms, setReasonTerms] = useState('')
    const [termsAccepted, setTermsAccepted] = useState(true);
    const sp = `${process.env.REACT_APP_LOCAL_SERVER}/php/onlinebooking`;
    const [messages, addMessage] = useMessages();
    const { state } = useStateMachine({ updateAction });

    useEffect(() => {

        async function fetchData() {
            fetch(`${process.env.REACT_APP_LOCAL_SERVER}/php/onlinebooking/config.php?action=terms&reason=${state.reason}`)
                .then(async (response) => {
                    const termsResult = await response.json();
                    //console.log(setupResult);
    
                    if (termsResult.result === "Success") {
                        if (termsResult.terms) {
                            setReasonTerms(termsResult.terms);
                            setTermsAccepted(false);
                        } else {
                            setReasonTerms('');
                            setTermsAccepted(true);
                        }
                    }
                })
                .catch((error) => {
                    //setPageError(true);
                    console.error('There was an error!', error);
                });
        }
    
        fetchData();
    }, [state.reason]);

    const handleSubmit = async (event) => {
        // Block native form submission.
        event.preventDefault();

        if (!stripe || !elements) {
            return;
        }
        //props.finishFnc();

        //addMessage('Creating payment intent...');

        //const cardElement = elements.getElement(CardElement);
        //console.log('card', cardElement);
        //console.log('stripe', stripe);

        // Create payment intent on the server
        const requestOptions = {
            method: 'POST',
            mode: "cors",
            body: JSON.stringify({ paymentMethodType: 'card', currency: 'gbp', amount: state.fee, practice_id: localStorage.getItem('practice_id') })
        };
        fetch(sp + '/stripe/card.php', requestOptions)
            .then(async response => {
                const result = await response.json();
                //console.log(result);

                if (!result) {
                    addMessage('Error: Cannot connect to back-end server for Stripe payment request.');
                    return;
                }

                if (result.error) {
                    addMessage(result.error);
                    return;
                }

                addMessage('Processing payment, please wait...');
                // Confirm the payment on the client
                const { error: stripeError, paymentIntent } = await stripe.confirmCardPayment(
                    result.client_secret, {
                    payment_method: {
                        card: elements.getElement(CardNumberElement),
                    }
                }
                )
                
                if (stripeError) {
                    addMessage(stripeError.message);
                    return;
                }

                //console.log(paymentIntent);

                addMessage(`PaymentIntent (${paymentIntent.id}): ${paymentIntent.status}`);

                if (paymentIntent.status === 'succeeded') {
                    props.finishFnc();
                }

            })
            .catch(error => {
                //setPageError(true);
                //console.error('There was an error!', error);
            });

    };

    const ELEMENT_OPTIONS = {
        style: {
            base: {
                fontSize: '18px',
                color: 'black',
                backgroundColor: 'white',
                innerHeight: '500px',
                letterSpacing: '0.025em',
                '::placeholder': {
                    color: '#aab7c4',
                },
            },
            invalid: {
                color: 'red',
            },
        },
    };

    return (
        <>
            <form id="payment-form" onSubmit={handleSubmit} className="stripe-form">
                <label htmlFor="cardNumber">Card Number</label>
                <CardNumberElement
                    id="cardNumber"
                    options={ELEMENT_OPTIONS}
                />
                <label htmlFor="expiry">Card Expiration</label>
                <CardExpiryElement
                    id="expiry"
                    options={ELEMENT_OPTIONS}
                />
                <label htmlFor="cvc">CVC</label>
                <CardCvcElement
                    id="cvc"
                    options={ELEMENT_OPTIONS}
                />
                <label htmlFor="postal">Postal Code</label>
                <input
                    id="postal"
                    required
                    className="stripe-postcode-input"
                    autoCapitalize="off"
                    placeholder="AB1 2CD"
                    value={postal}
                    onChange={(e) => {
                        setPostal(e.target.value);
                    }}
                />
                {reasonTerms.length > 0 &&
                <>
                    <input type="checkbox" id="bookingTerms" ref={termsCheck} onChange={() => setTermsAccepted(termsCheck.current.checked) }/>
                    <label for="bookingTerms" dangerouslySetInnerHTML={{__html:reasonTerms}}></label>
                </>
                }
                <div className="space-between"> 
                    <button className="booking-btns" type="submit" disabled={!termsAccepted}>Pay £{state.fee / 100}</button>
                    <button className="booking-btns" type="button" onClick={() => history.push(`/home`)}>Cancel</button>
                </div>
            </form>
            <StatusMessages messages={messages} />
        </>
    );
};

export default function BookPayment(props) {

    const { state } = useStateMachine();
    const fetchOptions = { cachePolicy: 'no-cache' }
    const { get } = useFetch(`${process.env.REACT_APP_LOCAL_SERVER}/php/onlinebooking`, fetchOptions)

    const [stripePromise, setStripePromise] = useState();

    useEffect(() => {
        async function fetchData() {
            const result = await get(`/config.php?action=stripe_key&practice_id=${localStorage.getItem('practice_id')}`);

            // Make sure to call `loadStripe` outside of a component’s render to avoid
            // recreating the `Stripe` object on every render.
            setStripePromise(await loadStripe(result.publishableKey));
        }

        if (props.tabIndex === 2)
            fetchData();
    }, [props.tabIndex, props.tabTime, get])

    return (
        <>
        {/* <h1> Test Card Number: 4000008260000000</h1> */}
            {stripePromise ?
                <Elements stripe={stripePromise}>
                    <h4 className="booking-text">A deposit/payment of £{state.fee / 100} is required to complete your booking for {state.reason_desc}.</h4>

                    <CheckoutForm finishFnc={props.finishFnc} />
                </Elements>
                :
                <div>Setting up payment request. One moment.</div>
            }
        </>
    )
}